// import React, { useState, useEffect, useRef } from 'react';
// import { stats } from '../mockData';

// const Stats = () => {
//   const [isVisible, setIsVisible] = useState(false);
//   const [counters, setCounters] = useState({});
//   const sectionRef = useRef(null);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting && !isVisible) {
//           setIsVisible(true);
//         }
//       },
//       { threshold: 0.3 }
//     );

//     if (sectionRef.current) {
//       observer.observe(sectionRef.current);
//     }

//     return () => {
//       if (sectionRef.current) {
//         observer.unobserve(sectionRef.current);
//       }
//     };
//   }, [isVisible]);

//   useEffect(() => {
//     if (!isVisible) return;

//     const animateCounter = (targetValue, index, duration = 2000) => {
//       const start = performance.now();
      
//       // Parse target value
//       let numericTarget = 0;
//       let suffix = '';
//       let isPercentage = false;
//       let isSpecial = false;

//       if (targetValue.includes('%')) {
//         numericTarget = parseFloat(targetValue.replace('%', ''));
//         suffix = '%';
//         isPercentage = true;
//       } else if (targetValue.includes('+')) {
//         numericTarget = parseInt(targetValue.replace(/[^0-9]/g, ''));
//         suffix = '+';
//       } else if (targetValue.includes('-')) {
//         // Special case like "1-click"
//         isSpecial = true;
//         return targetValue;
//       } else {
//         numericTarget = parseInt(targetValue.replace(/[^0-9]/g, ''));
//       }

//       if (isSpecial) {
//         setCounters(prev => ({ ...prev, [index]: targetValue }));
//         return;
//       }

//       const animate = (currentTime) => {
//         const elapsed = currentTime - start;
//         const progress = Math.min(elapsed / duration, 1);
        
//         // Easing function for smooth animation
//         const easeOutQuart = 1 - Math.pow(1 - progress, 4);
//         const currentValue = numericTarget * easeOutQuart;

//         let displayValue;
//         if (isPercentage) {
//           displayValue = currentValue.toFixed(2) + suffix;
//         } else {
//           displayValue = Math.floor(currentValue).toLocaleString() + suffix;
//         }

//         setCounters(prev => ({ ...prev, [index]: displayValue }));

//         if (progress < 1) {
//           requestAnimationFrame(animate);
//         } else {
//           // Set final exact value
//           if (isPercentage) {
//             setCounters(prev => ({ ...prev, [index]: numericTarget.toFixed(2) + suffix }));
//           } else {
//             setCounters(prev => ({ ...prev, [index]: numericTarget.toLocaleString() + suffix }));
//           }
//         }
//       };

//       requestAnimationFrame(animate);
//     };

//     // Start all counters
//     stats.items.forEach((item, index) => {
//       animateCounter(item.value, index);
//     });
//   }, [isVisible]);

//   return (
//     <section ref={sectionRef} className="py-32 px-6 relative overflow-hidden">
//       <div 
//         className="absolute inset-0 bg-cover bg-center"
//         style={{ backgroundImage: `url(${stats.backgroundImage})` }}
//       >
//         <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/60 to-black/70"></div>
//       </div>
      
//       <div className="max-w-7xl mx-auto relative z-10">
//         <div className="text-center mb-20 text-white">
//           <p className="text-brand-blue-300 text-sm font-bold mb-6 tracking-wide uppercase">{stats.badge}</p>
//           <h2 className="text-5xl md:text-6xl font-bold mb-8 leading-tight">{stats.title}</h2>
//           <p className="text-xl text-gray-200 max-w-3xl mx-auto">{stats.subtitle}</p>
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
//           {stats.items.map((item, index) => (
//             <div key={index} className="bg-white/10 backdrop-blur-lg rounded-3xl p-10 text-center hover:bg-white/20 hover:scale-105 transition-all duration-500 border border-white/10">
//               <div className="text-6xl md:text-7xl font-bold text-white mb-6 bg-gradient-to-br from-white to-gray-300 bg-clip-text text-transparent">
//                 {counters[index] || (item.value.includes('-') ? item.value : '0')}
//               </div>
//               <p className="text-gray-200 text-base leading-relaxed">{item.label}</p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Stats;

import React, { useState, useEffect, useRef } from 'react';
import { stats } from '@/mockData';

const Stats = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [counters, setCounters] = useState({});
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isVisible) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [isVisible]);

  useEffect(() => {
    if (!isVisible) return;

    const animateCounter = (targetValue, index, duration = 2000) => {
      const start = performance.now();
      
      // Parse target value
      let numericTarget = 0;
      let suffix = '';
      let isPercentage = false;
      let isSpecial = false;

      if (targetValue.includes('%')) {
        numericTarget = parseFloat(targetValue.replace('%', ''));
        suffix = '%';
        isPercentage = true;
      } else if (targetValue.includes('+')) {
        numericTarget = parseInt(targetValue.replace(/[^0-9]/g, ''));
        suffix = '+';
      } else if (targetValue.includes('-')) {
        // Special case like "1-click"
        isSpecial = true;
        return targetValue;
      } else {
        numericTarget = parseInt(targetValue.replace(/[^0-9]/g, ''));
      }

      if (isSpecial) {
        setCounters(prev => ({ ...prev, [index]: targetValue }));
        return;
      }

      const animate = (currentTime) => {
        const elapsed = currentTime - start;
        const progress = Math.min(elapsed / duration, 1);
        
        // Easing function for smooth animation
        const easeOutQuart = 1 - Math.pow(1 - progress, 4);
        const currentValue = numericTarget * easeOutQuart;

        let displayValue;
        if (isPercentage) {
          displayValue = currentValue.toFixed(2) + suffix;
        } else {
          displayValue = Math.floor(currentValue).toLocaleString() + suffix;
        }

        setCounters(prev => ({ ...prev, [index]: displayValue }));

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          // Set final exact value
          if (isPercentage) {
            setCounters(prev => ({ ...prev, [index]: numericTarget.toFixed(2) + suffix }));
          } else {
            setCounters(prev => ({ ...prev, [index]: numericTarget.toLocaleString() + suffix }));
          }
        }
      };

      requestAnimationFrame(animate);
    };

    // Start all counters
    stats.items.forEach((item, index) => {
      animateCounter(item.value, index);
    });
  }, [isVisible]);

  return (
    // Komponen ini sudah gelap, jadi tidak ada perubahan besar
    <section ref={sectionRef} className="py-32 px-6 relative overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${stats.backgroundImage})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/60 to-black/70"></div>
      </div>
      
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-20 text-white">
          <p className="text-brand-blue-300 text-sm font-bold mb-6 tracking-wide uppercase">{stats.badge}</p>
          <h2 className="text-5xl md:text-6xl font-bold mb-8 leading-tight">{stats.title}</h2>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">{stats.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.items.map((item, index) => (
            // Card ini sudah transparan dan gelap, tidak perlu diubah
            <div key={index} className="bg-white/10 backdrop-blur-lg rounded-3xl p-10 text-center hover:bg-white/20 hover:scale-105 transition-all duration-500 border border-white/10">
              <div className="text-6xl md:text-7xl font-bold text-white mb-6 bg-gradient-to-br from-white to-gray-300 bg-clip-text text-transparent">
                {counters[index] || (item.value.includes('-') ? item.value : '0')}
              </div>
              <p className="text-gray-200 text-base leading-relaxed">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;